/*------------------------------------*\
    Define function with options
\*------------------------------------*/
function lsRepo(){





    /*------------------------------------*\
        options:
    \*------------------------------------*/
    this.options = {
        namespace: 'lsRepo'
    };




    /*------------------------------------*\
        updateIndex:
        updates items index
    \*------------------------------------*/
    this.updateIndex = function(name){

        var indexName = this.options.namespace + '_index';

        var oldIndex = localStorage.getItem( indexName );
        var index = JSON.parse(oldIndex);

        index.push(name);

        var newIndex = JSON.stringify(index);

        localStorage.setItem(indexName, newIndex);
    };







    /*------------------------------------*\
        getIndexCount
        counts all items
        (without quantity)
    \*------------------------------------*/
    this.getIndexCount = function(){

        var indexName = this.options.namespace + '_index';


        var rawIndex = localStorage.getItem(indexName);
        var index = JSON.parse(rawIndex);
        return index.length;
    };







    /*------------------------------------*\
        searchItemByID:
        searches item by its ID property
        and returns its name
    \*------------------------------------*/
    this.searchItemByID = function(id, all){

        var matchedItems = []

        for (var i = 0; i < this.getIndexCount(); i++) {

            var name = this.options.namespace + '_' + (i + 1);
            var data = JSON.parse( localStorage.getItem(name) );

            if ( String(data.id) === String(id) ) {

                if (!!all) {
                    matchedItems.push(id)
                } else {
                    return name;
                }

            }

        }

        return !!all ? matchedItems : false;

    };



    /*------------------------------------*\
        searchItemByUID:
        searches item by its UID property
        and returns its name
    \*------------------------------------*/
    this.searchItemByUID = function(uid, all){

        var matchedItems = []

        for (var i = 0; i < this.getIndexCount(); i++) {

            var name = this.options.namespace + '_' + (i + 1);
            var data = JSON.parse( localStorage.getItem(name) );

            if ( String(data.uid) === String(uid) ) {

                if (!!all) {
                    matchedItems.push(uid)
                } else {
                    return name;
                }

            }

        }

        return !!all ? matchedItems : false;

    };




    /*------------------------------------*\
        changeQuantity:
        adds quantity to existing item
    \*------------------------------------*/
    this.changeQuantity = function(id, quantity, triggerEvents){

        var name = this.searchItemByID(id);

        var data = JSON.parse( localStorage.getItem(name) );

        data.quantity += quantity;

        var newData = JSON.stringify(data);

        localStorage.setItem(name, newData);



        // fire it only in 2 cases:
        // * when triggerEvents isn't defined
        // * when triggerEvents is set to true
        if (typeof triggerEvents === 'undefined' || triggerEvents) {
            $(window).trigger(this.options.namespace + '-quantitychanged', data);
        }

    };








    /*------------------------------------*\
        addItem:
        id property required
    \*------------------------------------*/
    this.addItem = function(data, triggerEvents, communicateToBackend){

        if (typeof data === 'undefined' || !data) {
            console.error('lsRepoError: \'data\' parameter is not defined');
            return false;
        }

        if (typeof communicateToBackend == 'undefined') {
            communicateToBackend = true;
        }


        if (typeof data.id === 'undefined') {
            console.error('lsRepoError: \'id\' property is not defined');
            return false;
        }




        // if item exists exit function
        // update: do not exit to allow multiple items
        if (false && this.searchItemByID(data.id)) {


            /*
            //and maybe add quantity?

            // quantity property not declared
            if (typeof data.quantity === 'undefined') {
                this.changeQuantity(data.id, 1);
            }

            // quantity property declared
            else {
                this.changeQuantity(data.id, data.quantity);
            }
            */

            // fire it only in 2 cases:
            // * when triggerEvents isn't defined
            // * when triggerEvents is set to true
            if (typeof triggerEvents === 'undefined' || triggerEvents) {
                $(window).trigger(this.options.namespace + '-alreadyadded', data);
            }


            return true;
        }





        // quantity property not declared
        if (typeof data.quantity === 'undefined') {
            data.quantity = 1;
        }

        var number = this.getIndexCount() + 1;
        var name = this.options.namespace + '_' + number;
        var value = JSON.stringify(data);

        localStorage.setItem(name, value);
        this.updateIndex(name);


        // fire it only in 2 cases:
        // * when triggerEvents isn't defined
        // * when triggerEvents is set to true
        if (typeof triggerEvents === 'undefined' || triggerEvents) {
            $(window).trigger(this.options.namespace + '-newitem', data, communicateToBackend);
        }


    };









    /*------------------------------------*\
        getItem:
    \*------------------------------------*/
    this.getItem = function(id){
        var name = this.searchItemByID(id);
        var item = localStorage.getItem(name);
        return item;
    };






    /*------------------------------------*\
        getAllItems:
        returns all objects
    \*------------------------------------*/
    this.getAllItems = function(){

        var items = {};

        for (var i = 0; i < this.getIndexCount(); i++) {
            var name = this.options.namespace + '_' + (i + 1);
            var item = localStorage.getItem(name);
            items[name] = JSON.parse(item);
        }

        return items;

    };







    /*------------------------------------*\
        removeAll:
        removes all items
    \*------------------------------------*/
    this.removeAll = function(triggerEvents){

        for (var i = 0; i < this.getIndexCount(); i++) {
            var name = this.options.namespace + '_' + (i + 1);
            localStorage.removeItem(name);
        }

        var indexName = this.options.namespace + '_index';
        localStorage.setItem(indexName, '[]');


        // fire it only in 2 cases:
        // * when triggerEvents isn't defined
        // * when triggerEvents is set to true
        if (typeof triggerEvents === 'undefined' || triggerEvents) {
            $(window).trigger(this.options.namespace + '-removeall');
        }

    };





    /*------------------------------------*\
        remove:
        removes single item
        in rather hacky way
        but simple!
    \*------------------------------------*/
    this.remove = function(id, triggerEvents){

        // delete from localstorage
        var itemsCopy = this.getAllItems();
        var nameToDelete = this.searchItemByID(id);
        delete itemsCopy[nameToDelete];

        // delete all
        this.removeAll(0);

        // add again everything, one by one from stored copy
        for (var key in itemsCopy) {
            this.addItem(itemsCopy[key], 0);
        }

        // fire it only in 2 cases:
        // * when triggerEvents isn't defined
        // * when triggerEvents is set to true
        if (typeof triggerEvents === 'undefined' || triggerEvents) {
            $(window).trigger(this.options.namespace + '-remove', id);
        }

    };



    /*------------------------------------*\
        remove by uid:
        removes single item
        in rather hacky way
        but simple!
    \*------------------------------------*/
    this.removeUid = function(uid, triggerEvents){

        // delete from localstorage
        var itemsCopy = this.getAllItems();
        var nameToDelete = this.searchItemByUID(uid);
        delete itemsCopy[nameToDelete];

        // delete all
        this.removeAll(0);

        // add again everything, one by one from stored copy
        for (var key in itemsCopy) {
            this.addItem(itemsCopy[key], 0);
        }

        // fire it only in 2 cases:
        // * when triggerEvents isn't defined
        // * when triggerEvents is set to true
        if (typeof triggerEvents === 'undefined' || triggerEvents) {
            $(window).trigger(this.options.namespace + '-removeuid', uid);
        }

    };





    /*------------------------------------*\
        update:
    \*------------------------------------*/
    this.update = function(id, property, value, triggerEvents){


        var allItems = this.getAllItems();
        var nameToUpdate = this.searchItemByID(id);
        var itemData = allItems[nameToUpdate];
        delete allItems[nameToUpdate];

        itemData[property] = value;
        var stringifiedItemData = JSON.stringify(itemData);

        localStorage.setItem(nameToUpdate, stringifiedItemData);


        // fire it only in 2 cases:
        // * when triggerEvents isn't defined
        // * when triggerEvents is set to true
        if (typeof triggerEvents === 'undefined' || triggerEvents) {
            $(window).trigger(this.options.namespace + '-update', id);
        }


    };





    /*------------------------------------*\
        init:
        sets namespace and
        creates index object
    \*------------------------------------*/
    this.init = function(namespace, triggerEvents){

        if (typeof namespace === 'undefined') {
            throw 'lsRepoError: \'namespace\' property is not defined';
        }

        this.options.namespace = namespace;

        var indexName = this.options.namespace + '_index';

        if ( localStorage.getItem(indexName) === null ) {
            localStorage.setItem(indexName, '[]');
        }


        // fire it only in 2 cases:
        // * when triggerEvents isn't defined
        // * when triggerEvents is set to true
        if (typeof triggerEvents === 'undefined' || triggerEvents) {
            $(window).trigger(this.options.namespace + '-init');
        }

    };





}





module.exports = lsRepo;



// WEBPACK FOOTER //
// ./js-source/base/ls-repo.js